import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges, ChangeDetectorRef } from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MenuItem } from './menu.model';
import { TranslateService } from '@ngx-translate/core';
import { SiderbarService } from 'src/app/siderbar.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  selectedMenuItem: any = null;
  showModuleModal: boolean = false;
  @ViewChild('sideMenu') sideMenu: ElementRef;
  @ViewChild('componentRef') scrollRef;
  @Input() isCondensed = false;
  menu: any;
  data: any;
  isClass: boolean = true;
  menuItems = [];
  currentUser: any;

  renderer: any;

  constructor(
    private router: Router, public translate: TranslateService, private http: HttpClient,
    private sidemenuService: SiderbarService,
    private authService: AuthenticationService,
    private aroute: ActivatedRoute,
    private cd: ChangeDetectorRef) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    this.authService.currentUserSubject.subscribe((response) => {
      this.currentUser = response;
      this.sidemenuService.ShowMenu();
      this._refreshMenu();
      this.cd.detectChanges();
    })

    this.currentUser = this.authService.currentUserValue;
    var currentPath = this.aroute.firstChild.snapshot.routeConfig.path;
    // this.sidemenuService.ShowMenu();
    this.initialize();
    this._scrollElement();

    this.sidemenuService.activeMenus.subscribe((updatedValue) => {
      this.menuItems = updatedValue;
      // var menu = this.menuItems.filter(x => x.isVisible == false);
      // menu.forEach(item => {
      //   if (item.subItems) {
      //     var menuItem = item.subItems.find(x => x.link == '/' + currentPath);
      //     if (menuItem == undefined) {
      //       var subList = item.subItems.find(x => x.subItems != null)?.subItems.find(c => c.link == '/' + currentPath);
      //       if (subList != undefined) this.sidemenuService.ShowMenu(item.id);
      //     } else {
      //       this.sidemenuService.ShowMenu(item.id);
      //     }
      //   }
      // })
    });
  }

  ngAfterViewInit() {
    this._initMetisMenu();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }



  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  private _initMetisMenu() {
    if (this.menu) {
      this.menu.dispose();
    }
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  private _refreshMenu() {
    setTimeout(() => {
      this._initMetisMenu();
    }, 100);
  }

  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }


  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems ? true : false;
  }
  showMyContainer: boolean = false;

  onMenuItemClick(item: any) {
    if (item.modulePath) {
      // Modal show karo, navigation delay karo
      this.selectedMenuItem = item;
      this.showModuleModal = true;
    } else {
      // Agar modulePath nahi hai toh seedha onClick call karo jaisa pehle hota tha
      this.onClick(item);
    }
  }

  onModalConfirm() {
    if (this.selectedMenuItem) {
      this.onClick(this.selectedMenuItem);  // Original onClick call karo modal confirm pe
      this.closeModal();
    }
  }

  closeModal() {
    this.showModuleModal = false;
    this.selectedMenuItem = null;
  }

  onClick(item: any) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (item.modulePath) {
      // Check if 'currentUser' and 'token' exist
      if (currentUser && currentUser.token) {
        const token = currentUser.token; // Use 'token' here instead of 'authToken'
        const baseUrl = 'https://stage2.lemurtechnologies.com';
        // Construct the target URL with the token
        const targetUrl = `${baseUrl}/${item.modulePath}?token=${encodeURIComponent(token)}&moduleName=${item.modulePath}`;
        // Perform the redirection directly without opening the dropdown
        window.location.href = targetUrl; // Navigate to Lemur2 with the token
      } else {
        // If no token found, handle this case (e.g., redirect to login or show an error)
        console.log('No token found, redirecting to login');
        window.location.href = 'https://stage2.lemurtechnologies.com/auth/login';
      }
    }
    else if (item.id == 91) {
      if (currentUser && currentUser.token) {
        window.open('https://academy.lemurmaritime.com/login-otp/', '_blank', 'noopener');
      }
      else {
        // If no token found, handle this case (e.g., redirect to login or show an error)
        console.log('No token found, redirecting to login');
        window.location.href = 'https://stage2.lemurtechnologies.com/auth/login';
      }
    }
  }
}
